export type CnhCategory = 'A' | 'B' | 'C' | 'D' | 'E' | 'AB' | 'AC' | 'AD' | 'AE';

export interface Driver {
  id: string;
  name: string;
  cpf: string;
  rg: string | null;
  cnh: string;
  cnhCategory: CnhCategory;
  cnhFirstIssueAt: string | null;
  cnhExpiresAt: string;
  cnhPoints: number;
  birthDate: string | null;
  phone: string | null;
  email: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  notes: string | null;
  active: boolean;
  /** true quando o motorista ja tem login no app (driver.userId preenchido). */
  hasAppAccess: boolean;
  userId: string | null;
  createdAt: string;
  updatedAt: string;
  version: number;
}

export interface DriversListResponse {
  data: Driver[];
  meta: { page: number; limit: number; total: number };
}

export const CNH_CATEGORIES: CnhCategory[] = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'AB',
  'AC',
  'AD',
  'AE',
];

export const BR_STATES = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
  'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
] as const;
